export const logger = (...params: (string | any)[]) => {
  console.log(params)
}